export const regionID = 'us-central1';
export var PythonFunctionName;
(function (PythonFunctionName) {
    PythonFunctionName["CREATE_NURSE_CALENDAR"] = "create_nurse_calendar";
    PythonFunctionName["EDIT_TRACKING_NUMBER"] = "edit_tracking_number";
    PythonFunctionName["GET_PROCEDURE_CONFIGS"] = "get_procedure_configs";
    PythonFunctionName["GET_SHIFT_EVENT_LOG"] = "get_shift_event_log";
    PythonFunctionName["GET_SHIPMENT_MANIFEST"] = "get_shipment_manifest";
    PythonFunctionName["PROCESS_QUEUE_ITEM"] = "process_queue_item";
    PythonFunctionName["RUN_DAILY"] = "run_daily";
    PythonFunctionName["SET_TIME_SLOTS_TRIGGER"] = "set_time_slots_trigger";
    PythonFunctionName["TRACK_SCHEDULING_ATTEMPT_DATA"] = "track_scheduling_attempt_data";
    PythonFunctionName["UPDATE_TIME_SLOTS"] = "update_time_slots";
})(PythonFunctionName || (PythonFunctionName = {}));
//# sourceMappingURL=cloudPython.js.map